/**
 * Web type helpers.
 *
 * `Web.Type` arrives as its wire label — "Online Event", "Download", "Meeting", "Demo" — because the
 * API serializes the enum through its `[Description]` rather than as a number. There is no generated
 * union to narrow it (see dashboard/CLAUDE.md), so the check lives here once instead of being spelled
 * out at each call site, which is how three slightly different spellings of it accumulated (ORB-826).
 */

/**
 * Whether a web type is the Online Event type — the only type with a start and an end, and so the only
 * one whose pages have pre / live / post states. Tolerant of spacing and casing for the same reason the
 * field is a string: nothing checks the value at the boundary.
 */
export function isOnlineEventType(type?: string | null): boolean {
    return (type || '').replace(/\s+/g, '').toLowerCase() === 'onlineevent'
}
